import { FC } from "react";

export const StarFilledIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 18.2752L7.85001 20.7752C7.66668 20.8919 7.47501 20.9419 7.27501 20.9252C7.07501 20.9085 6.90001 20.8419 6.75001 20.7252C6.60001 20.6085 6.48334 20.4629 6.40001 20.2882C6.31668 20.1129 6.30001 19.9169 6.35001 19.7002L7.45001 14.9752L3.77501 11.8002C3.60834 11.6502 3.50434 11.4792 3.46301 11.2872C3.42101 11.0959 3.43334 10.9085 3.50001 10.7252C3.56668 10.5419 3.66668 10.3919 3.80001 10.2752C3.93334 10.1585 4.11668 10.0835 4.35001 10.0502L9.20001 9.6252L11.075 5.1752C11.1583 4.9752 11.2877 4.8252 11.463 4.7252C11.6377 4.6252 11.8167 4.5752 12 4.5752C12.1833 4.5752 12.3627 4.6252 12.538 4.7252C12.7127 4.8252 12.8417 4.9752 12.925 5.1752L14.8 9.6252L19.65 10.0502C19.8833 10.0835 20.0667 10.1585 20.2 10.2752C20.3333 10.3919 20.4333 10.5419 20.5 10.7252C20.5667 10.9085 20.5793 11.0959 20.538 11.2872C20.496 11.4792 20.3917 11.6502 20.225 11.8002L16.55 14.9752L17.65 19.7002C17.7 19.9169 17.6833 20.1129 17.6 20.2882C17.5167 20.4629 17.4 20.6085 17.25 20.7252C17.1 20.8419 16.925 20.9085 16.725 20.9252C16.525 20.9419 16.3333 20.8919 16.15 20.7752L12 18.2752Z"
      fill="currentColor"
    />
  </svg>
);
